export const SUB_GROUP_DROPPABLE_TYPE = 'SUB_GROUP'
export const GROUP_DROPPABLE_TYPE = 'GROUP'
export const GROUP_ITEM_DROPPABLE_TYPE = 'GROUP_ITEM'
export const SUB_GROUP_ITEM_DROPPABLE_TYPE = 'SUB_GROUP_ITEM'
export const UNGROUPED_ITEM_DROPPABLE_TYPE = 'UNGROUPED_ITEM'
export const TENANT_LOGIN_ITEM_DROPPABLE_TYPE = 'TENANT_LOGIN_ITEM'

export const DRAGGING_START_LEFT_POSITION = 32
